import { createSlice } from '@reduxjs/toolkit'

export interface AppState {
    isPortal: boolean,
    isReady: boolean,
    loading: boolean,
    resourceLoaded: boolean,
    workspace_slug: string | null
}

const initialState: AppState = {
    isPortal: false,
    isReady: false,
    loading: false,
    resourceLoaded: false,
    workspace_slug: null
}

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        ready: (state) => {
            state.isReady = true
        },
        notReady: (state) => {
            state.isReady = false
        },
        resourceLoaded: (state) => {
            state.resourceLoaded= true;
        },
        setWorkspace: (state, ws_slug) => {
            state.workspace_slug = ws_slug.payload;
        }
    }
})

export const { ready, notReady, resourceLoaded, setWorkspace } = appSlice.actions

export default appSlice.reducer
